import type { ImageProps } from '@ztechapps/webui.util'
import { Image } from '@ztechapps/webui.util'
import { toSize1Image } from '@ztechapps/common.utils'
import React from 'react'

export const ProductSize1Image = ({ url, ...props }: ImageProps) => {
  return <Image url={toSize1Image(url)} {...props} />
}
